<div class="container-fluid" [ngClass]="A04CDE== null ? 'advanced-mt-4' : 'advanced-mt-0'">

  <!-- MODAL -->
  <ng-template #contenido let-modal>
    <div class="modal-header">
      <h4 class="modal-title"></h4>
      <button type="button" class="btn-close btn-rounded " data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" style="padding-top: 0px;padding-bottom: 0px;">
      <app-advancedtable [WsURL]=strWsURLModal [WsLlaves]=WsLlavesModal  [WsSeleccion]=WsSeleccionModal (RetornoModal)=RetornoModalLista($event)
        [mostrarModal]=true>
      </app-advancedtable>
      <div *ngIf="currentPDF">
        <object [data]="getSafeUrl()" type="application/pdf" width="100%" height="600px">
        </object>
      </div>
    </div>
  </ng-template>
  <!-- END MODAL -->

  <!-- BEGIN Mantenimiento Interno -->
  <div *ngIf="this.MsDetalle=='S' && this.WsMsDataInterno != '' ">
    <app-simple-ms [WsData]=this.WsMsDataInterno (CerrarMsInterno)="EventoCerrarMSInterno($event)"></app-simple-ms>
  </div>
  <!-- END Mantenimiento Interno -->

  <!-- BEGIN Toolbar -->

  <div class="row mb-3" *ngIf="this.WsMsDataInterno == ''">
    <div class="col-md-12">
      <div class="card mb-0" style="background-color: transparent;">
        <div class="card-body" style="padding: 0.5em;">
          <div class="row align-items-center">
            <div class="col-md-6 col-sm-12">
              <ng-container *ngIf="!this.mostrarbreitem">
                <ng-container *ngIf="A04CDE== null; else wizard">
                  <div class="page-header-pro">
                    <div class="page-header-left">
                      <div class="title-chip">
                        <i class="fas fa-layer-group title-chip-icon"></i>
                        <span>{{TituloPantalla}}</span>
                      </div>
                      <div class="page-meta">
                        <span class="meta-badge">
                          <i class="fas fa-building"></i>
                          {{companiaActual}}
                        </span>
                        <span class="meta-sep">·</span>
                        <span class="meta-badge">
                          <i class="fas fa-map-marker-alt"></i>
                          {{sedeActual}}
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #wizard>
                  <div class="breadcrumb-pro">
                    <div class="breadcrumb-pro-item">
                      <i class="fas fa-layer-group breadcrumb-pro-icon"></i>
                      <span>{{TituloPantalla}}</span>
                    </div>
                    <i class="fas fa-chevron-right breadcrumb-pro-arrow"></i>
                    <div class="breadcrumb-pro-item breadcrumb-pro-active">
                      <span>{{A04CDE}}</span>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
              <div class="page-title-right" *ngIf="this.mostrarbreitem">
                <ol class="breadcrumb m-0">
                  <li class="breadcrumb-item active"><b>{{this.TituloPantalla}} </b></li>
                </ol>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 contenedor-botones " style="text-align: end">

              <ng-container *ngIf="this.toolbar">
                <div class="d-inline-block bloque mb-1" *ngFor="let boton of this.toolbar[0].NORMALES">
                  <div ngbDropdown class="d-inline-block" *ngIf="boton.Evento == 'IMPRIMIR';else otrosBotones">
                    <button type="button" title="{{boton.Tooltip}}" id="{{boton.Evento}}" name="{{boton.Evento}}"
                      class="btn blanco btn-label waves-light" ngbDropdownToggle
                      [ngStyle]="{'background-color': boton.class }">
                      <i class="fas fa-print label-icon" style="pointer-events:none ;"></i>
                      {{boton.boton}}
                    </button>
                    <div ngbDropdownMenu>
                      <button ngbDropdownItem (click)="EventoClickToolbar($event, boton.URL, 'PDF')"
                        id="{{boton.Evento}}" name="{{boton.Evento}}PDF">PDF</button>
                      <button ngbDropdownItem (click)="EventoClickToolbar($event, boton.URL, 'XLS')"
                        id="{{boton.Evento}}" name="{{boton.Evento}}XLS">XLS</button>
                      <button ngbDropdownItem (click)="EventoClickToolbar($event, boton.URL, 'NAV')"
                        id="{{boton.Evento}}" name="{{boton.Evento}}NAV">Abrir en Nav</button>
                    </div>
                  </div>

                  <ng-template #otrosBotones>

                    <button type="button" title="{{boton.Tooltip}}" id="{{boton.Evento}}" name="{{boton.Evento}}"
                      (click)="EventoClickToolbar($event, boton.URL, '', boton.boton)" class="btn blanco btn-label waves-light"
                      [ngStyle]="{'background-color': boton.class }" *ngIf="boton.Evento != 'IMPRIMIR_FIRMAR'">
                      <i class="fas {{boton.icono}} label-icon" style="pointer-events:none ;"></i>
                      {{boton.boton}}
                    </button>
                  </ng-template>
                </div>

                <div class="d-inline-block bloque mb-1" *ngIf="!mostrarModal">
                  <div ngbDropdown class="d-inline-block" *ngIf="this.toolbar[0].OPERACIONES.length > 0">
                    <button type="button" title="Procesos" class="btn blanco btn-label waves-light" ngbDropdownToggle
                      [ngStyle]="{'background-color': '#f3a462' }">
                      <i class="fas fa-solid fa-ellipsis-vertical label-icon" style="pointer-events:none ;"></i>
                      Procesos
                    </button>
                    <div ngbDropdownMenu>
                      <ng-container *ngFor="let OPERACIONES of this.toolbar[0].OPERACIONES">
                        <button *ngIf="OPERACIONES" ngbDropdownItem
                          (click)="EventoClickToolbar($event, OPERACIONES.URL, '', OPERACIONES.boton)" id="{{OPERACIONES.Evento}}"
                          name="{{OPERACIONES.Evento}}"> {{OPERACIONES.boton}}</button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>

              <div class="d-inline-block bloque mb1" *ngIf="!mostrarModal && reportes.length > 0">
                <button *ngIf="this.tipo_pantalla !== 'REPORTE'" style="background-color: #86aec4; color: white;"
                  type="button" title="Filtrar" (click)="open()" class="btn btn-label waves-light">
                  <i class="fas fa-print label-icon" style="pointer-events:none; "></i>
                  Reportes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
      <!-- <hr class="mt-1" style="border-top: 6px solid var(--app-oscuro, #0c7cb3);"> -->
    </div>
  </div>
  <!-- END Toolbar -->

  <!-- Slot de extensiones específicas por pantalla -->
  <app-extension-slot
    *ngIf="extensionContext && SYS02EXT?.length"
    [extensiones]="SYS02EXT"
    [context]="extensionContext"
    (retornoGrabar) = recargarDesdeExtension($event)>
  </app-extension-slot>

  <div class="row mb-3" *ngIf="mostrarModal && ActivarFiltro=='S'">
    <div class="col-12" *ngIf="form_template$">
      <div ngbAccordion>
        <div ngbAccordionItem [destroyOnHide]="false">
          <h6 ngbAccordionHeader>
            <button ngbAccordionButton>
              <div class="text-end w-100">
                <i class="fa fa-filter fa-xl me-2"></i>
              </div>
            </button>
          </h6>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                    <div class="card mb-0" style="background-color: var(--app-muy-claro, #edf4f9);box-shadow: 0px 3px 8px;">
                      <div class="card-body">
                        <app-filtrocampo [form_template]="form_template$  | async" [strListener]="strEventListener"
                          [blnMostrarBusqueda]="true && tipo_pantalla!='REPORTE'" [TipoPantalla]="tipo_pantalla"
                          [MostrarbotonBuscar]="'true'" [Mostrartitulofiltro]="Mostrartitulofiltro"
                          (cerrar)="cerrarmodal($event)">
                        </app-filtrocampo>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-alerta [SYS41ARC]="this.SYS41ARC"></app-alerta>
  
  <!-- <ng-container *ngIf="respFiltros.length > 0 && this.WsMsDataInterno == ''">
    <div ngbAccordion *ngIf="respFiltros[0].FiltrosAvanzado.length > 0" class="filtros-accordion mb-3" #acc="ngbAccordion">
      <div ngbAccordionItem [destroyOnHide]="false"> -->
  
        <!-- Header -->
        <!-- <h6 ngbAccordionHeader class="filtros-header">
          <button ngbAccordionButton class="filtros-toggle">
            <div class="d-flex align-items-center gap-2">
              <span class="filtros-icon-wrap">
                <i class="fa fa-sliders-h"></i>
              </span>
              <span class="filtros-label">Filtros Avanzados</span>
            </div>
            <i class="fa fa-chevron-down filtros-chevron"></i>
          </button>
        </h6> -->
  
        <!-- Body -->
        <!-- <div ngbAccordionCollapse>
          <div ngbAccordionBody class="filtros-body">
            <ng-template>
              <div class="row mb-0">
                <div class="col-md-12">
                  <app-filtrocampo 
                    [form_template]="respFiltros"
                    [blnAccionbuscar]="blnAccionbuscar"
                    [strListener]="strEventListener"
                    [blnMostrarBusqueda]="true"
                    [TipoPantalla]="tipo_pantalla"
                    [formFiltros]="formFiltros"
                    [FiltrosAvan]="1"
                    [Mostrartitulofiltro]="Mostrartitulofiltro">
                  </app-filtrocampo>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </ng-container> -->


  <!-- IFRAME para exportar datos -->
  <div class="row" *ngIf="safeURL">
    <iframe [src]="safeURL" width="0px" height="0px" style='display:hidden'>
    </iframe>
  </div>

  <div class="row" *ngIf="this.WsMsDataInterno == ''">
    <div [ngClass]="blnFiltrosAbiertos ? 'col-9' : 'col-12'">
      <div class="card" style="background-color: transparent; box-shadow: none;" *ngIf="this.tipo_pantalla !='REPORTE'">
        <div class="card-body" style="padding: 0">
          <div class="row">
            <div class="col-md-12 " *ngIf="this.tipo_pantalla=='LISTADO' && this.strSYS02TIP=='CAL'">
              <div class="row align-items-center" *ngIf="!mostrarModal">

                <div class="col-6">

                </div>

                <div style="text-align: right;" class="col-6">
                  <button type="button"
                    [ngClass]="this.favorito_pantalla == 'N' ? 'btn btn-light btn-label waves-light' : 'btn btn-warning btn-label waves-light' "
                    (click)="GrabarFavorito()" *ngIf="this.ActivarFavorito == 'S'" title="Favoritos">
                    <i
                      [ngClass]="this.favorito_pantalla == 'N' ? 'far fa-star label-icon ' : 'fas fa-star label-icon ' "></i>
                    Favoritos
                  </button>
                  <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                  <button type='button' style="margin-left: 0.5em; background-color: var(--app-claro, #3ac6dd); color: var(--app-texto-claro, #fff);"
                    class="btn btn-label waves-light " (click)="BuscarAvanzado()">
                    <i class="bx bx-search-alt-2 label-icon"></i> Buscar
                  </button>
                  <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                  <button type="button" style="margin-left: 0.5em; background-color: var(--app-claro, #35adc9); color: var(--app-texto-claro, #fff);"
                    class=" btn btn-label waves-light " (click)="limpiarbusqueda()" title="Limpiar">
                    <i class="fa fa-broom label-icon"></i> Limpiar
                  </button>
                  <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                  <button *ngIf="this.SYS02TUT != ''" type='button' style="margin-left: 0.5em; background-color: var(--app-primario, #1f92b5);"
                    class="btn btn-label waves-light" (click)="abrirAyuda()" title="Tutorial">
                    <i class="fa fa-file-circle-question label-icon"></i> Tutorial
                  </button>
                </div>
              </div>
              <br>
              <app-lazy-heavy type="calendario"
                [inputs]="{
                  tableData2: tableData2,
                  WsLlaves: WsLlaves,
                  UrlClickLista: UrlClickLista,
                  llaves: llaves,
                  tableData3: tableData3
                }"
                [outputs]="{ parentAbrirURL: AbrirURL.bind(this) }">
              </app-lazy-heavy>
            </div>
            <div class="col-md-12 " *ngIf="this.tipo_pantalla=='LISTADO' && this.strSYS02TIP!='CAL'">
              <div class="row align-items-center" *ngIf="!mostrarModal">
                <div style="text-align: right;" class="offset-6 col-6">
                  
                </div>
              </div>
              <br>

              <!-- BEGIN DataTable -->
              <div class="table-pro-wrapper">

                <div class="filtros-avanzados-wrapper" 
                  [@slideInOut]="mostrarFiltrosAvanzados ? 'in' : 'out'"
                  *ngIf="respFiltros?.length > 0 && respFiltros[0].FiltrosAvanzado?.length > 0">
                
                <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                <div style="padding: 20px; background-color: var(--app-muy-claro, #eef6fb); border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);" 
                    class="row mb-3">
                  <div class="col-md-12">
                    <app-filtrocampo 
                      [form_template]="respFiltros"
                      [blnAccionbuscar]="blnAccionbuscar"
                      [strListener]="strEventListener"
                      [blnMostrarBusqueda]="true"
                      [TipoPantalla]="tipo_pantalla"
                      [formFiltros]="formFiltros"
                      [FiltrosAvan]="1"
                      [Mostrartitulofiltro]="Mostrartitulofiltro">
                    </app-filtrocampo>
                  </div>
                </div>
              </div>
                
                <!-- HEADER INTEGRADO -->
                <div class="table-pro-header d-flex justify-content-between align-items-center mb-2">
                  
                  <div class="header-side-left">
                    <button
                      *ngIf="respFiltros?.length > 0 && respFiltros[0].FiltrosAvanzado?.length > 0"
                      type="button"
                      class="btn btn-light border d-inline-flex align-items-center gap-2 btn-filtros-azul"
                      (click)="toggleFiltrosAvanzados()"
                      title="Filtros avanzados"
                      [class.active]="mostrarFiltrosAvanzados">
                      <i class="fa fa-sliders-h"></i>
                      <span>Filtros avanzados</span>
                      <i class="fa fa-chevron-down transition-icon"
                        [class.rotated]="mostrarFiltrosAvanzados"></i>
                    </button>
                  </div>
                  
                  <div class="header-side-right" *ngIf="this.tipo_pantalla=='LISTADO' && this.strSYS02TIP!='CAL'">
                    <div *ngIf="!mostrarModal">
                      <button type="button"
                        [ngClass]="this.favorito_pantalla == 'N' ? 'btn btn-secondary btn-label waves-light' : 'btn btn-warning btn-label waves-light'"
                        (click)="GrabarFavorito()" *ngIf="this.ActivarFavorito == 'S'" title="Favoritos">
                        <i [ngClass]="this.favorito_pantalla == 'N' ? 'far fa-star label-icon ' : 'fas fa-star label-icon ' "></i>
                        Favoritos
                      </button>
                      <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                      <button type='button' style="margin-left: 0.5em; background-color: var(--app-claro, #3ac6dd); color: var(--app-texto-claro, #fff);"
                        class="btn btn-label waves-light" (click)="BuscarAvanzado()" title="Buscar">
                        <i class="fa fa-search label-icon"></i> Buscar
                      </button>
                      <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                      <button type="button" style="margin-left: 0.5em; background-color: var(--app-claro, #35adc9); color: var(--app-texto-claro, #fff);"
                        class=" btn btn-label waves-light" (click)="limpiarbusqueda()" title="Limpiar">
                        <i class="fa fa-broom label-icon "></i> Limpiar
                      </button>
                      <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                      <button *ngIf="this.SYS02TUT != ''" type='button' style="margin-left: 0.5em; background-color: var(--app-primario, #1f92b5);"
                        class="btn btn-label waves-light" (click)="abrirAyuda()" title="Tutorial">
                        <i class="fa fa-file-circle-question label-icon"></i> Tutorial
                      </button>
                    </div>
                  </div>

                </div>

                <div class="table-responsive">
                  <table class="table-avatar mb-0 table-striped">
                    <thead>
                      <tr class="thead">
                        <td>
                          <a class="form-check">
                            <input class="form-check-input" #chkTabla type="checkbox" (click)="checktodos($event)" [value]="-1">
                          </a>
                        </td>
                        <td *ngFor="let col of ColumnasSN">
                          {{col.A03DES}}
                          <a href="javascript: void(0);" (click)="ordendes(col.A03COD)" *ngIf="!order_mostrar">
                            <i class="iconoorden fa-solid fa-arrow-up-wide-short"></i>
                          </a>
                          <a href="javascript: void(0);" (click)="ordenasc(col.A03COD)" *ngIf="order_mostrar">
                            <i class="iconoorden fa-solid fa-arrow-down-short-wide"></i>
                          </a>
                        </td>
                        <td *ngIf="operaciones.length > 0" style="width: 1%; min-width: 80px; white-space: nowrap;"></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="tableData2.length == 0; else registros">
                        <td [colSpan]="ColumnasSN.length + 2" class="empty-row-container">
                          <div class="empty-state-content">
                            <div class="empty-icon">
                              <i class="fas fa-folder-open"></i>
                            </div>
                            <h5 class="empty-title">Sin registros</h5>
                            <p class="empty-text">No hay información que cumpla con los filtros indicados</p>
                          </div>
                        </td>
                      </tr>

                      <ng-template #registros>
                        <tr *ngFor="let table of this.tableData2 | slice: (currentPage-paginaBase) * itemsPerPage : (currentPage-paginaBase+1) * itemsPerPage; let i=index">
                          <td>
                            <a class="form-check">
                              <input class="form-check-input" [checked]="table.checkado" #chkTabla type="checkbox" [value]="table.INDEX">
                            </a>
                          </td>
                          <td *ngFor="let col of ColumnasSN; let j=index">
                            <div (click)="EventoClickLista($event, table.INDEX)"
                              [ngClass]="{'to-left': col.SYS03TIP == 'F' || col.SYS03TIP == 'N'}">
                              {{table[col.A03COD]}}
                            </div>
                          </td>
                          <td *ngIf="operaciones.length > 0" class="cell-operaciones">
                            <ng-container *ngFor="let operacionbutton of operaciones; let i=index">
                              <button type="button" title="{{operacionbutton.boton}}" 
                              *ngIf="operacionbutton.SYS16MET=='S'" 
                              (click)="EventoClickOperacion(operacionbutton, table.INDEX, i)" 
                              id={{table.INDEX}} 
                              class="btn blanco fa-sm" 
                              [ngStyle]="{'background-color': operacionbutton.class}">
                                <i class="fas {{operacionbutton.icono}} label-icon"></i>
                              </button>
                            </ng-container>
                          </td>
                        </tr>
                      </ng-template>

                    </tbody>
                  </table>
                </div>

                <!-- FOOTER -->
                <div class="table-pro-footer" *ngIf="tableData2.length > 0">
                  
                  <div class="footer-side-spacer"></div>

                  <!-- Paginador -->
                  <ngb-pagination
                    [page]="currentPage"
                    [pageSize]="itemsPerPage"
                    [collectionSize]="(currentPage * itemsPerPage) + 1"
                    #paginateList
                    (pageChange)="pageChange($event)"
                    class="pro-pagination">
                    <ng-template ngbPaginationPrevious><i class="fa-solid fa-caret-left"></i> Ant</ng-template>
                    <ng-template ngbPaginationNext>Sig <i class="fa-solid fa-caret-right"></i></ng-template>
                    <ng-template ngbPaginationPages let-page let-pages="pages">
                      @if (pages.length > 0) {
                        <li class="ngb-custom-pages-item mx-2">
                          <label class="col-form-label me-2">Página</label>
                          <input type="number" min="1" class="pro-input-page"
                            [(ngModel)]="paginaInput"
                            (keyup.enter)="irAPagina()"
                            (keydown.tab)="irAPagina()"
                            (change)="irAPagina()">
                        </li>
                      }
                    </ng-template>
                  </ngb-pagination>

                  <!-- Selector registros -->
                  <div class="table-pro-pagesize">
                    <span>Mostrando</span>
                    <select class="pro-select" name="pageSize" (change)="countNumber($event.target.value)">
                      <option *ngFor="let number of number">{{number}}</option>
                    </select>
                    <span>Registros</span>
                  </div>

                </div>

              </div>
              <!-- END DataTable -->
            </div>
            <!-- END LISTA DE DATOS -->
          </div>
        </div>
      </div>
    </div>


    <!-- Filtro solo para tipo de pantalla Reporte -->
    <div class="row" *ngIf="this.tipo_pantalla === 'REPORTE' ">
      <app-reportes [reportes]="this.reportes" [strListener]="this.strEventListener"
        [filtrosReporte]="this.filtrosReporte" [blnMostrarBusqueda]="tipo_pantalla=='REPORTE'"
        [AccionesOnChange]="AccionesOnChange" [TipoPantalla]="tipo_pantalla"
        [SYS02CON]="this.intSYS02CON"
        [favorito_pantalla]="this.favorito_pantalla"
        (AbrirNuevoNav)="AbrirReporteComponentePDFNav($event)" [isImprimir]="toolbar[0].NORMALES.length == 0">
      </app-reportes>
    </div>

    <label class="table__label">[{{this.intSYS02CON}}] Backend {{ this.TiempoBackend }} Front {{ DiferenciaTiempo() }}
    </label>
  </div>
</div>
<app-scroll-to-top>
</app-scroll-to-top>
